// AnalyticsListener.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

export default function AnalyticsListener() {
  const location = useLocation();

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    if (!process.env.REACT_APP_GA_TRACKING_ID) return;

    const page = location.pathname + location.search;

    // Send GA4 page_view for SPA navigation
    ReactGA.send({ hitType: "pageview", page });
    ReactGA.set({ page });
  }, [location]);

  return null;
}